import { render, staticRenderFns } from "./cyberattacks.vue?vue&type=template&id=64c6fdb2&scoped=true&"
import script from "./cyberattacks.vue?vue&type=script&lang=js&"
export * from "./cyberattacks.vue?vue&type=script&lang=js&"
import style0 from "./cyberattacks.vue?vue&type=style&index=0&id=64c6fdb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c6fdb2",
  null
  
)

export default component.exports